module.exports = __webpack_public_path__ + "static/media/sam-lose.a13a4f14.png";